import styles from '@/styles/job-card.module.css';
import { Job } from '@/types/job';
import { faWheelchair } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Icon } from '@mui/material';
import Link from '@/components/link-with-utms';
import { formatJobTitle } from '@/utils/format-job-title';

export interface JobCardProps {
  job: Job;
}
export default function JobCard({ job }: JobCardProps) {
  return (
    <Box className={styles.job_card}>
      <Link href={`/vagas/emprego/${job.slug}`}>
        <div className={styles.header}>
          <h3 className={styles.job_title}>{formatJobTitle(job.title)}</h3>
          {!!job.pcd && (
            <Icon className={styles.pcd_icon} role="img" aria-label="Vaga para pessoa com deficiência">
              <FontAwesomeIcon icon={faWheelchair} style={{ color: `#373F41` }} />
            </Icon>
          )}
        </div>
        <p className={styles.company_location}>{`${job.companyName?.toUpperCase()} - ${job.city}, ${job.state}`}</p>
      </Link>
    </Box>
  );
}
